import { Box, Flex } from '@mantine/core';
import DeviceTypeIcon from 'components/device/DeviceTypeIcon';
import P2Regular from 'components/typography/P2Regular';
import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';

/**
 * Column for the device's own type (Zariadenie).
 */
export default function DeviceDeviceTypeColumn({ data: { device } }: { data: RevisionPlanRow }) {
  return (
    <Flex gap={8}>
      <Box w={24} h={24}>
        <DeviceTypeIcon typeId={device.deviceType.deviceTypeId} />
      </Box>
      <P2Regular color="gray.8">{device.deviceType.deviceTypeName}</P2Regular>
    </Flex>
  );
}
